import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/data-model.js';
import { isSameData } from '../../models/dto/data-model-utils.js';
import { BackstageTicket } from '../../models/serializable/backstage-ticket.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class BackstageTicketComponent extends Component {
  static readonly TYPE_ID: string = '95ec51d271ae48d2bfa6c0ab4e117c58';

  private constructor(
    public readonly ticket: BackstageTicket,
  ) {
    super();
  }

  get $typeId(): string {
    return BackstageTicketComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  static create(args: {
    ticket: BackstageTicket,
  }): BackstageTicketComponent {
    return new BackstageTicketComponent(
        args.ticket,
    );
  }

  static fromData(
      context: SerializationContext,
      map: SerializedData,
  ): BackstageTicketComponent {
    return new BackstageTicketComponent(
        context.fromData<BackstageTicket>(MapUtils.get<SerializedData>(map, 'ticket')),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      ticket: context.toData(this.ticket),
    };
  }

  clone(): this {
    return new BackstageTicketComponent(
        this.ticket.clone(),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.ticket, this.ticket);
  }
}

export class BackstageTicketComponentBuilder extends DataModelBuilder<BackstageTicketComponent> {
  build(context: SerializationContext, map: SerializedData): BackstageTicketComponent {
    return BackstageTicketComponent.fromData(context, map);
  }
}
